<template>
  <div class="flex items-start justify-between py-6" :data-testid="`event-invite-quota-${quotaId}`">
    <div>
      <h4 class="mb-3 text-headline-xs" data-testid="invite-quota-title">
        {{ props.quota.title || props.quota.ticketCategory?.titleEn }}
      </h4>
      <MarkdownContent :unstyled="true" class="enable-lists text-body-s" :md="getLocalizedDescription" />
      <ul v-if="isInternalQuotaType && quota.fields.length" class="pt-1">
        <li v-for="(field, index) in quota.fields" :key="index" class="ml-6 list-disc">
          <p class="mb-2 text-body-s-medium">{{ field.name }}</p>
          <MarkdownContent :unstyled="true" class="enable-lists ps-4 text-body-s" :md="getLocalizedFieldDescription(field)" />
        </li>
      </ul>
    </div>

    <div class="flex-shrink-0 text-right">
      <RouterLink
        class="btn-primary-color-s"
        data-testid="invite-quota-list"
        :to="{ name: 'invitationQuota', params: { invitationQuotaId: quotaId } }"
      >
        {{ t('InvitationQuota.showList') }}
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MarkdownContent } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { internalQuotaTypes } from '@/components/InternalQuota/quotaConfig'
import type { EventQuery, Field } from '@/gql/myomr'
import { toPlainId } from '@/helpers/globalIdHelper'
import { getLocalizedAttribute } from '@/helpers/localizedAttribute'

const { t, locale } = useI18n()

const props = defineProps<{
  quota: NonNullable<EventQuery['eventById']['invitationQuotas']>[number]
}>()

const getLocalizedDescription = computed(() =>
  getLocalizedAttribute({
    de: props.quota.descriptionDe,
    en: props.quota.descriptionEn,
    fallback: '',
    locale: locale.value,
  }),
)

const isInternalQuotaType = computed(() => internalQuotaTypes.includes(props.quota.kind))

const getLocalizedFieldDescription = (field: Field) =>
  getLocalizedAttribute({
    de: field.descriptionDe,
    en: field.descriptionEn,
    fallback: '',
    locale: locale.value,
  })

const quotaId = computed(() => toPlainId(props.quota.id))
</script>

<style>
.enable-lists ul {
  list-style: disc !important;
}
</style>
